 

export default function PublicHeader() {
  return (
    <>
      <header className="w-full bg-white shadow-md">
        <div className="w-full max-w-[1100px] mx-auto flex h-12 min-h-12 items-center justify-between px-3 sm:px-6">
          <a href="https://dezshop.ro" className="inline-flex items-center" aria-label="dezShop homepage">
            <img
              src="/images/logo-dez.svg"
              alt="dezShop"
              className="h-9 w-auto"
            />
          </a>
          <div id="public-header-actions" className="flex items-center gap-2" />
        </div>
      </header>
    </>
  );
}


